export { ThemeIcon } from '@mantine/core'
